import { Component } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { AssetService } from 'src/app/project/modules/fleet-management/asset-service/asset.service';
import { AssetDashboardService } from 'src/app/project/modules/fleet-management/fleet-management-fleet-page/fleet-assets/asset-card/asset-dashboard/asset-dashboard.service';
import { TDashlet, TDashletSiteRange } from 'src/app/project/modules/preferences/preferences.model';
import { TEditCostComparisonModalData } from '../edit-cost-comparison-dashlet-modal/edit-cost-comparison-modal.consts';

@Component({
  selector: 'pp-edit-value-breakdown-dashlet-modal',
  templateUrl: './edit-value-breakdown-dashlet-modal.component.html',
  styleUrl: './edit-value-breakdown-dashlet-modal.component.scss',
  standalone: false,
})
export class EditValueBreakdownDashletModalComponent {
  dashlet: TDashlet;
  assetId: string;
  initialDashletData: TDashletSiteRange;
  initialDashletName: string;

  constructor(
    private modalService: ModalService,
    private assetService: AssetService,
    private assetDashboardService: AssetDashboardService,
  ) {}

  ngOnInit(): void {
    const modalData: TEditCostComparisonModalData = this.modalService.getModal().data;

    this.dashlet = modalData.dashlet;
    this.assetId = modalData.assetId;

    this.initialDashletData = {
      workspaceId: this.dashlet.selectedRange?.workspaceId || '',
      numericalCustomFieldId: this.dashlet.selectedRange?.numericalCustomFieldId || '',
      listCustomFieldId: this.dashlet.selectedRange?.listCustomFieldId || '',
    };

    this.initialDashletName = this.dashlet.customName;
  }

  editDashlet({
    selectedRange,
    customName,
  }: {
    selectedRange: TDashletSiteRange;
    customName: string;
  }): void {
    const dashlets = cloneDeep(this.assetService.getAsset(this.assetId).dashlets);
    const dashletIndex = this.findDashlet(dashlets);

    dashlets[dashletIndex].selectedRange = selectedRange;
    dashlets[dashletIndex].customName = customName;

    this.assetDashboardService.updateAssetDashboard(dashlets, this.assetId);
    this.modalService.hideModal();
  }

  deleteDashlet(): void {
    const dashlets = cloneDeep(this.assetService.getAsset(this.assetId).dashlets);
    const dashletIndex = this.findDashlet(dashlets);

    dashlets.splice(dashletIndex, 1);

    this.assetDashboardService.updateAssetDashboard(dashlets, this.assetId);
    this.modalService.hideModal();
  }

  private findDashlet(dashlets: TDashlet[]): number {
    return dashlets.findIndex(
      (dashlet) =>
        dashlet.name === this.dashlet.name &&
        dashlet.cols === this.dashlet.cols &&
        dashlet.rows === this.dashlet.rows &&
        dashlet.x === this.dashlet.x &&
        dashlet.y === this.dashlet.y,
    );
  }
}
